import { Editors, Filters } from 'angular-slickgrid';
import { FieldDefinition } from '../field-definition';
import { GenericValidator } from '../../generic-form/model/generic-validator';
import { GenericFormField } from '../../generic-form/model/generic-field';
import { ValidationTypes } from '../../generic-form/enums/validation-types';
import { ControlTypes } from '../../generic-form/enums/control-types';
import { BaseFieldBuilder } from './field-builder.base';

export class DropdownFieldBuilder extends BaseFieldBuilder {
  private _required = false;
  private validators: GenericValidator[] = [];
  private _options: { key: string; value: string }[] = [];
  private _optionsLoader?: (params?: any) => any;

  constructor(key: string, label: string) {
    super(key, label, ControlTypes.Dropdown);
  }

  required(): this {
    this._required = true;
    this.validators.push(new GenericValidator({ key: ValidationTypes.Required }));
    return this;
  }

  options(options: { key: string; value: string }[]): this {
    this._options = options;
    return this;
  }

  optionsLoader(loader: (params?: any) => any): this {
    this._optionsLoader = loader;
    return this;
  }

  build(): FieldDefinition {
    const column = this.getBaseColumnConfig();
    const localizedLabel = this.getLocalizationKey();

    // Factory to create editor with options
    if (!this.readOnlyValue) {
      column.createEditor = (_localizationService: any) => {
        return {
          model: Editors.singleSelect,
          collection: this._options.map(opt => ({
            value: opt.key,
            label: opt.value,
          })),
          required: this._required,
        };
      };
    }

    // Factory to create filter
    column.createFilter = (_localizationService: any) => {
      return {
        model: Filters.singleSelect,
        collection: this._options.map(opt => ({
          value: opt.key,
          label: opt.value,
        })),
      };
    };

    return {
      key: this.key,
      label: localizedLabel,
      column,
      fieldOptions: new GenericFormField({
        key: this.key,
        label: localizedLabel,
        controlType: this._controlType,
        required: this._required,
        validators: this.validators,
        hidden: this.hideInChildFormsValue,
        hiddenByDefault: this.hideByDefaultValue,
        readOnly: this.readOnlyValue,
        showReadOnlyInForm: this.showReadOnlyInFormValue,
        dependencies: this.dependencyRules.length ? this.dependencyRules : undefined,
        prefilter: this.prefilterOptions,
        options: this._options,
        optionsLoader: this._optionsLoader,
      }),
    };
  }
}
